import React from 'react'
import {
  STORE_SIZE,
  AREA_CODE,
  ALL_REGIONS_VALUE,
} from 'services/Stores/constants'
import { TagFilter } from 'shared-global-ec-uikit/components/dist/react/esm/components/tag-filter'
import { LinkTextGroup } from 'shared-global-ec-uikit/components/dist/react/esm/components/link-text-group'
import { LinkText } from 'shared-global-ec-uikit/components/dist/react/esm/components/link-text'
import { Filters as FiltersProp } from '../Filters/typings'
import { storeSizeFilters, filterTranslationMap } from '../constants'
import getConstants from '../../../../constants'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Label } from 'shared-global-ec-uikit/components/dist/react/esm/components/label'
export type Props = {
  intl: any
  areas: AreasType
  filters: FiltersProp
  onFilter: (filters: { [key: string]: boolean | string }) => void
  onClearFilters: () => void
  onAreaChange: (areaCode?: string) => void
}

const { IS_EU: isEU, EU_COUNTRY_LIST: euCountries } = getConstants()

const ActiveFilters = (props: Props) => {
  if (countActiveFilters(props.filters) === 0) {
    return null
  }

  const {
    filters: { activeFiltersOrder },
    onFilter,
    intl,
    onClearFilters,
    onAreaChange,
  } = props

  const renderActiveFilters = (
    filters: Array<{ [key: string]: string | boolean }>,
  ) => {
    return filters.map(activeFilter =>
      Object.entries(activeFilter).map(([key, value]) => {
        if (key === STORE_SIZE) {
          const selectedStoreSize = storeSizeFilters.find(
            entry => entry.value === value,
          )
          return selectedStoreSize ? (
            <TagFilter
              value={intl.formatMessage({
                id: selectedStoreSize.translationKey,
              })}
              variant="interactive"
              onClick={() => onFilter({ storeSize: '' })}
            />
          ) : null
        } else if (key === AREA_CODE) {
          return value && value !== ALL_REGIONS_VALUE ? (
            <TagFilter
              value={
                !isEU
                  ? props.areas[value as string]
                  : intl.formatMessage({
                      id:
                        euCountries.find(
                          country => country.countryCode === value,
                        )?.lid || value,
                    })
              }
              variant="interactive"
              onClick={() => onAreaChange()}
            />
          ) : null
        } else {
          return (
            <div className="mb3">
              <TagFilter
                value={intl.formatMessage({ id: filterTranslationMap[key] })}
                variant="interactive"
                onClick={() => onFilter({ [key]: false })}
              />
            </div>
          )
        }
      }),
    )
  }

  return (
    <>
      <div>
        <div className="fr-ec-mb-spacing-02">
          <Label element="em" variant="secondary">
            <FormattedMessage id="text_active_filters" />
          </Label>
        </div>

        <LinkTextGroup legend="Active Filters" className="fr-ec-mb-spacing-01">
          {renderActiveFilters(activeFiltersOrder)}

          {countActiveFilters(props.filters) > 1 ? (
            //Tag filter group here
            <LinkText
              element="a"
              href="#"
              variant="standalone"
              onClick={onClearFilters}
            >
              <FormattedMessage id="text_sort_clearfilters" />
            </LinkText>
          ) : (
            []
          )}
        </LinkTextGroup>
      </div>
    </>
  )
}

export const countActiveFilters = (filters: FiltersProp) => {
  const {
    departmentFilters,
    accessFilters,
    selectedStoreSizeFilter,
    otherFilters,
    storeServiceFilters,
  } = filters
  const departmentFiltersCount = Object.entries(departmentFilters).filter(
    ([key, isSet]) => isSet,
  ).length
  const accessFiltersCount = Object.entries(accessFilters).filter(
    ([key, isSet]) => isSet,
  ).length
  const storeSizeFilterCount = selectedStoreSizeFilter ? 1 : 0
  const otherFiltersCount = Object.values(otherFilters).filter(value => value)
    .length
  const storeServiceFiltersCount = Object.entries(storeServiceFilters).filter(
    ([key, isSet]) => isSet,
  ).length

  return (
    departmentFiltersCount +
    accessFiltersCount +
    storeSizeFilterCount +
    otherFiltersCount +
    storeServiceFiltersCount
  )
}

export default injectIntl(ActiveFilters)
